let API_URL = 'https://aiducatortestingapisv2.ctsdemo.ae';



export { API_URL };
